import { PostgreSQL, sql, type SQLDialect, SQLite } from "@codemirror/lang-sql";
import { EditorView, type Extension } from "@uiw/react-codemirror";
import { EDITOR_SURFACE } from "../../common/editor-theme";
import { catalogueCompletion } from "./completion";
import type { ModeId, Schema } from "./engine";

// The whole of the editor for one dialect, plus the completion that answers from the database the page is holding.
// The reader is what makes that second half live without this array moving: it is memoised on the mode alone, since
// a new one is a reconfiguration and a reconfiguration after every run would take the undo history with it.
export function editorExtensions(mode: ModeId, read: () => Schema[]): Extension[] {
  return [...DIALECT_EXTENSIONS[mode], catalogueCompletion(DIALECTS[mode], mode, read)];
}

const DIALECTS: Record<ModeId, SQLDialect> = { sqlite: SQLite, postgres: PostgreSQL };

// A dialect is what the parser is built from rather than a setting a running editor can be switched into, so both are
// made up front and the page swaps between them — the shape /javascript's two language modes take.
const DIALECT_EXTENSIONS: Record<ModeId, Extension[]> = {
  sqlite: extensions("sqlite"),
  postgres: extensions("postgres"),
};

function extensions(mode: ModeId): Extension[] {
  // Keywords complete in upper case, which is how the sample above the caret and every message in the log spell them.
  return [sql({ dialect: DIALECTS[mode], upperCaseKeywords: true }), EditorView.lineWrapping, ...EDITOR_SURFACE];
}
